/**
 * Image + video slots for the clear aligner page.
 * Every `src` must be a DIRECT public image URL that works inside a plain
 * <img> tag. If you swap in a Google Drive file, use the direct thumbnail
 * form — https://drive.google.com/thumbnail?id=FILE_ID&sz=w1200 — never the
 * normal "sharing" link, which does not render as an image.
 */
export type MediaSlot = {
  id: string
  /** Direct public image URL. Replace with the final clinic photo when ready. */
  src: string
  /** What the photo shows (also used as the caption if the URL ever fails). */
  brief: {
    en: string
    ua: string
    ru: string
    ro: string
  }
}

export const alignerMedia: MediaSlot[] = [
  {
    id: 'hero',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8aef519f-321b-4fb1-848c-86e2e8bf06b1.jpg',
    brief: {
      en: 'Close-up of transparent aligners on teeth',
      ua: 'Крупний план прозорих елайнерів на зубах',
      ru: 'Крупный план прозрачных элайнеров на зубах',
      ro: 'Prim-plan cu gutiere transparente pe dinți',
    },
  },
  {
    id: 'planning',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d1da4d19-9c4a-4b50-bf41-073e1cb899ba.jpg',
    brief: {
      en: 'Clinician explaining the digital treatment plan on screen',
      ua: 'Лікар пояснює цифровий план лікування на екрані',
      ru: 'Врач объясняет цифровой план лечения на экране',
      ro: 'Medicul explică planul digital de tratament pe ecran',
    },
  },
  {
    id: 'trays',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a330d2c2-d84d-4c71-9d34-60f07abb2e5a.jpg',
    brief: {
      en: 'Clear aligners on a dental model',
      ua: 'Прозорі елайнери на стоматологічній моделі',
      ru: 'Прозрачные элайнеры на стоматологической модели',
      ro: 'Gutiere transparente pe un model dentar',
    },
  },
  {
    id: 'case',
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/a96c6f3a-efff-423c-97aa-d10a1cec74b7.jpg',
    brief: {
      en: 'Patient holding an aligner case',
      ua: 'Пацієнт тримає футляр для елайнерів',
      ru: 'Пациент держит футляр для элайнеров',
      ro: 'Pacient ținând cutia pentru gutiere',
    },
  },
]

/** Video slot for the “See how clear aligners move teeth” section. */
export const alignerVideo: {
  /** MP4 / hosted video URL. Leave empty to keep the placeholder card. */
  src: string
  /** Poster frame shown before playback. */
  poster: string
} = {
  src: 'https://cdn.magicpatterns.com/uploads/8A38iEVmQacAjAJ4zwXzWt/Maria%20Hamalai-Primary%20Phase%20Plan%202_32JXEA%20(1).mp4',
  poster:
    'https://cdn.magicpatterns.com/patterns/generated-images/a330d2c2-d84d-4c71-9d34-60f07abb2e5a.jpg',
}

export function findMedia(id: string): MediaSlot | undefined {
  return alignerMedia.find((slot) => slot.id === id)
}
